import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { UserFragmentDoc } from '../../fragments/__generated__/User.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: { me: { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, productListImageSize: Types.ProductListImageSizeEnum, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null } | null } };

export type SignInMutationVariables = Types.Exact<{
  username: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type SignInMutation = { data: { errors: Array<{ messages: Array<string>, field: string }>, me: { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, productListImageSize: Types.ProductListImageSizeEnum, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null } | null } };

export type SignUpMutationVariables = Types.Exact<{
  firstName: Types.Scalars['String']['input'];
  lastName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  email: Types.Scalars['String']['input'];
  subscriptions?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  password: Types.Scalars['String']['input'];
  captcha: Types.Scalars['String']['input'];
  policyAgreement: Types.Scalars['Boolean']['input'];
}>;


export type SignUpMutation = { data: { errors: Array<{ messages: Array<string>, field: string }>, me: { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, productListImageSize: Types.ProductListImageSizeEnum, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null } | null } };

export type ResetPasswordFromKeyMutationVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
  token: Types.Scalars['String']['input'];
  newPassword1?: Types.InputMaybe<Types.Scalars['String']['input']>;
  newPassword2?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResetPasswordFromKeyMutation = { data: { errors: Array<{ field: string, messages: Array<string> }> } };

export type SocialAuthMutationVariables = Types.Exact<{
  provider: Types.Scalars['String']['input'];
  accessToken: Types.Scalars['String']['input'];
}>;


export type SocialAuthMutation = { socialAuth: { me: { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, productListImageSize: Types.ProductListImageSizeEnum, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null } | null } };


export const LogoutDocument = gql`
    mutation Logout {
  logout {
    me {
      ...UserFragment
    }
  }
}
    ${UserFragmentDoc}`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($username: String!, $password: String!) {
  data: signIn(input: {username: $username, password: $password}) {
    errors {
      messages
      field
    }
    me {
      ...UserFragment
    }
  }
}
    ${UserFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignUpDocument = gql`
    mutation SignUp($firstName: String!, $lastName: String, $email: String!, $subscriptions: Boolean, $password: String!, $captcha: String!, $policyAgreement: Boolean!) {
  data: signUp(
    input: {firstName: $firstName, lastName: $lastName, email: $email, subscriptions: $subscriptions, password: $password, captcha: $captcha, policyAgreement: $policyAgreement}
  ) {
    errors {
      messages
      field
    }
    me {
      ...UserFragment
    }
  }
}
    ${UserFragmentDoc}`;
export type SignUpMutationFn = Apollo.MutationFunction<SignUpMutation, SignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      subscriptions: // value for 'subscriptions'
 *      password: // value for 'password'
 *      captcha: // value for 'captcha'
 *      policyAgreement: // value for 'policyAgreement'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<SignUpMutation, SignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpMutation, SignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<SignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<SignUpMutation, SignUpMutationVariables>;
export const ResetPasswordFromKeyDocument = gql`
    mutation ResetPasswordFromKey($uid: String!, $token: String!, $newPassword1: String, $newPassword2: String) {
  data: userResetPasswordFromKey(
    uid: $uid
    token: $token
    input: {newPassword1: $newPassword1, newPassword2: $newPassword2}
  ) {
    errors {
      field
      messages
    }
  }
}
    `;
export type ResetPasswordFromKeyMutationFn = Apollo.MutationFunction<ResetPasswordFromKeyMutation, ResetPasswordFromKeyMutationVariables>;

/**
 * __useResetPasswordFromKeyMutation__
 *
 * To run a mutation, you first call `useResetPasswordFromKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordFromKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordFromKeyMutation, { data, loading, error }] = useResetPasswordFromKeyMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function useResetPasswordFromKeyMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordFromKeyMutation, ResetPasswordFromKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordFromKeyMutation, ResetPasswordFromKeyMutationVariables>(ResetPasswordFromKeyDocument, options);
      }
export type ResetPasswordFromKeyMutationHookResult = ReturnType<typeof useResetPasswordFromKeyMutation>;
export type ResetPasswordFromKeyMutationResult = Apollo.MutationResult<ResetPasswordFromKeyMutation>;
export type ResetPasswordFromKeyMutationOptions = Apollo.BaseMutationOptions<ResetPasswordFromKeyMutation, ResetPasswordFromKeyMutationVariables>;
export const SocialAuthMutationDocument = gql`
    mutation SocialAuthMutation($provider: String!, $accessToken: String!) {
  socialAuth(provider: $provider, accessToken: $accessToken) {
    me {
      ...UserFragment
    }
  }
}
    ${UserFragmentDoc}`;
export type SocialAuthMutationMutationFn = Apollo.MutationFunction<SocialAuthMutation, SocialAuthMutationVariables>;

/**
 * __useSocialAuthMutation__
 *
 * To run a mutation, you first call `useSocialAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialAuthMutation, { data, loading, error }] = useSocialAuthMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      accessToken: // value for 'accessToken'
 *   },
 * });
 */
export function useSocialAuthMutation(baseOptions?: Apollo.MutationHookOptions<SocialAuthMutation, SocialAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialAuthMutation, SocialAuthMutationVariables>(SocialAuthMutationDocument, options);
      }
export type SocialAuthMutationHookResult = ReturnType<typeof useSocialAuthMutation>;
export type SocialAuthMutationMutationResult = Apollo.MutationResult<SocialAuthMutation>;
export type SocialAuthMutationMutationOptions = Apollo.BaseMutationOptions<SocialAuthMutation, SocialAuthMutationVariables>;